module.exports = __webpack_public_path__ + "img/0124.8fd5efb2.png";